import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-solid",
  "use": "check-solid-usage",
  "viewBox": "0 0 61.66 54.61",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 61.66 54.61\" id=\"check-solid\"><title>check-solid</title><polygon points=\"9.26 20.59 0 30.4 25.63 54.61 61.66 8.28 51.01 0 24.1 34.61 9.26 20.59\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol